export const PRIMARY_COLORS = {
    red01: '#8E1317',
    red02: '#BE1B1F',
    red03: '#ED2227',
    red04: '#F14E52',
    red05: '#F47A7D',
    red06: '#FBD2D4',
  };
  
  export const SHADE_COLORS = {
    shade01: '#14171A',
    shade02: '#2C2E31',
    shade03: '#484C4E',
    shade04: '#797D7F',
    shade05: '#ADB1B4',
    shade06: '#E5E9EC',
    shade07: '#F2F4F6',
    shade08: '#FAFAFA',
    shade09: '#FFFFFF',
  };
  
  export const ACCENT_COLORS = {
    accent01: '#0C468D',
    accent02: '#1760BC',
    accent03: '#1B78EB',
    accent04: '#4893EF',
    accent05: '#75AFF3',
    accent06: '#D0E4FB',
  };
  
  export const ORANGE_COLORS = {
    orange01: '#92630A',
    orange02: '#C3840D',
    orange03: '#F4A511',
    orange04: '#F6B741',
    orange05: '#F8C970',
    orange06: '#FDEDCF',
  };
  
  export const GREEN_COLORS = {
    green01: '#08612E',
    green02: '#0C7D3B',
    green03: '#0A8B41',
    green04: '#3DA267',
    green05: '#6DB98D',
    green06: '#CEE8D9',
  };
  
  export const GRADIENT_COLORS = {
    gradient01: 'linear-gradient(270deg, #ED2227 -2.43%, #F4A511 100.99%)',
    gradient02: 'linear-gradient(90deg, #75AFF3 0%, #1760BC 100%)',
    gradient03: 'linear-gradient(270deg, #4893EF -2.43%, #30C67C 100.99%)',
    gradient04: 'linear-gradient(270deg, #14171A -2.43%, #797D7F 100.99%)',
    gradient05: 'linear-gradient(270deg, #3DA267 -2.43%, #0C7D3B 100.99%)',
  };
  
  export const YUMMY_COLORS = {
    yummy01: '#925914',
    yummy02: '#C3771C',
    yummy03: '#F49522',
    yummy04: '#F6AA4E',
    yummy05: '#F8BF7A',
    yummy06: '#FDEAD3',
  };

  export const colors = {
    callaLily: '#E5E9EC',
  flashWhite: '#F2F4F6',
  doctorWhite: '#FAFAFA',
  darkWillow: '#14171A',
  tarnishedSilver: '#797D7F',
  silverCharm: '#ADB1B4',
  blackLead: '#484C4E',
  ottomanRed: '#ED2227',
  ottomanRedDark: '#D81E21',
  sunScarlet: '#BE1B1F',
  maryRose: '#FBD2D4',
  deepSkyblue: '#1B78EB',
  deepSkyblueDark: '#1668CC',
  grassCourt: '#0A8B41',
  ottoIce: '#CEE8D9',
  squash: '#F4A511',
  sleepLamp: '#FDEDCF',
  circumorbital: '#6654C0',
  chineseSilver: '#6654C0',
  burningTrail: '#F49522',
  cloudless: '#D0E4FB',
  deepSkyBlue: '#1B78EB',
  amnesiaBlue: '#1760BC',
  oldTrail: '#C3840D',
  jordanJazz: '#0C7D3B',
  white: '#FFF',
  bastille: '#2C2E31',
  dairyMade: '#F6B741',
  greenish: '#3DA267',
    ...PRIMARY_COLORS,
    ...SHADE_COLORS,
    ...ACCENT_COLORS,
    ...ORANGE_COLORS,
    ...GREEN_COLORS,
    ...YUMMY_COLORS,
  };

  export const breakpoints = {
    sm: '320px',
    md: '992px',
    lg: '992px',
    xl: '1200px',
    '2xl': '1536px',
    md2: '768px',
    sm2: '374px',
    sm3: '480px',
    mdIframe: '890px',
    '768px': '768px',
    '576px': '576px',
    '414px': '414px',
    '320px': '320px',
  };
  